export enum YesNoUnknownEnum {
  Yes = 'Yes',
  No = 'No',
  Unknown = 'Unknown',
}
